<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <div>
        <input style='display: none' ref='fileInput' type='file' @change='handleFileUpload'>
        <v-btn text :loading='fileLoading' color='primary' x-small @click='$refs.fileInput.click()'>
          <v-icon size='20'>{{ icons.mdiCloudUploadOutline }}</v-icon>
          <span class='ml-1'>上传文件</span>
        </v-btn>
        <v-btn text x-small class='ml-1' color='primary' depressed
               @click='refresh'
               style='transform: translateX(-10px)'>
          <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
          <span class='ml-1'>刷新</span>
        </v-btn>
      </div>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :loading='tableLoading'
      size='small'
      :height='tableHeight'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column title='File Name'
                  :filters='[{}]'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
        <template #default='{ row }'>
          <a @click='downLoadFile(row)'>{{ row.fileName }}.{{ row.fileExt }}</a>
        </template>
      </vxe-column>
      <vxe-column field='createBy' title='Create By' :filters="[{ data: '' }]" width='200'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
      <vxe-column field='createTime' width='180' title='Create Time' sortable
                  show-header-overflow show-overflow />
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
  </div>
</template>
<script>
import { getFile, uploadFile, getChatBotFilePageList } from '../api/index'
import { mdiCloudUploadOutline, mdiRefresh } from '@mdi/js'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      icons: {
        mdiCloudUploadOutline, mdiRefresh,
      },
      searchParams: {
        nameOfJobList: [],
        createBy: null,
        likeType: null,
        likeTypeList: [],
        queryContent: null,
        answerContent: null,
      },
      selectedFile: null,
      fileLoading: false,
      tableHeight: 0,
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    refresh() {
      this.pagerOption.pageNum = 1
      this.pagerOption.pageSize = 20
      this.getPageList()
    },
    getScreenHeight() {
      this.tableHeight = window.innerHeight - 64 - 50 - 50
    },
    async handleFileUpload(event) {
      this.fileLoading = true
      this.selectedFile = event.target.files[0]
      if (!this.selectedFile) return
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      try {
        const { data: { code, data, msg } } = await uploadFile(formData)
        if (code === 200) {
          this.$message.success('上传成功')
          this.getPageList()
        } else {
          this.$message.error('上传失败')
          console.error('上传失败:', msg)
        }
      } catch (error) {
        this.$message.error('上传失败')
        console.error('上传失败:', error)
      }
      this.fileLoading = false
    },
    async downLoadFile(row) {
      try {
        // 发送请求获取二进制数据
        const response = await getFile({ fileId: row.fileId })

        // 创建 Blob 对象
        const blob = new Blob([response.data], { type: response.headers['content-type'] })

        // 创建 URL
        const url = window.URL.createObjectURL(blob)

        // 创建 a 标签
        const a = document.createElement('a')
        a.href = url
        // 设置下载的文件名
        a.download = row.fileName + '.' + row.fileExt
        a.click()

        // 释放 URL 对象
        window.URL.revokeObjectURL(url)
        // 移除创建的 a 标签
        a.remove()
      } catch (error) {
        console.error('下载文件出错:', error)
      }
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.createBy = null
      this.searchParams.nameOfJobList = []
      this.searchParams.likeTypeList = []
      this.searchParams.queryContent = null
      this.searchParams.answerContent = null
      filters.forEach(item => {
        if (item.property === 'nameOfJob') {
          this.searchParams.nameOfJobList = item.values
        } else if (item.property === 'likeType') {
          this.searchParams.likeTypeList = item.values
        } else {
          this.searchParams[item.property] = item.datas[0]
        }
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      const {
        data: {
          code,
          data,
        },
      } = await getChatBotFilePageList({ ...this.pagerOption, ...this.searchParams })
      if (code === 200) {
        this.dataList = data.records
        this.pagerOption.totalData = data.total
      }
      this.tableLoading = false
    },
  },
}
</script>
